import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollProgress from "@/components/ScrollProgress";
import Home from "@/pages/Home";
import Vision from "@/pages/Vision";
import About from "@/pages/About";
import WhatWeBuild from "@/pages/WhatWeBuild";
import Initiatives from "@/pages/Initiatives";
import Network from "@/pages/Network";
import Partner from "@/pages/Partner";
import AIOnCountry from "@/pages/AIOnCountry";
import Origins from "@/pages/Origins";
import StewardshipIntelligence from "@/pages/StewardshipIntelligence";
import ParticipatoryVideo from "@/pages/ParticipatoryVideo";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App grain min-h-screen bg-[#050806] text-[#F4F1ED]">
      <BrowserRouter>
        <ScrollToTop />
        <ScrollProgress />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/vision" element={<Vision />} />
            <Route path="/about" element={<About />} />
            <Route path="/what-we-build" element={<WhatWeBuild />} />
            <Route path="/ai-on-country" element={<AIOnCountry />} />
            <Route path="/stewardship-intelligence" element={<StewardshipIntelligence />} />
            <Route path="/initiatives" element={<Initiatives />} />
            <Route path="/participatory-video" element={<ParticipatoryVideo />} />
            <Route path="/network" element={<Network />} />
            <Route path="/origins" element={<Origins />} />
            <Route path="/partner" element={<Partner />} />
          </Routes>
        </main>
        <Footer />
        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "#101612",
              border: "1px solid #2C3430",
              color: "#F4F1ED",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
